// frontend/src/utils/axiosConfig.js
// ✅ نسخة محسّنة من Axios Interceptor

import axios from 'axios';
import tokenManager from './tokenManager';

// ✅ متغيرات لتتبع الطلبات الفاشلة
let failedQueue = [];
let isRefreshingToken = false;

/**
 * ✅ معالجة الطلبات المعلقة بعد تحديث التوكن
 */
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

/**
 * ✅ Response Interceptor - يتعامل مع انتهاء صلاحية التوكن
 */
axios.interceptors.response.use(
  // في حال نجاح الاستجابة
  (response) => response,

  // في حال فشل الاستجابة
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest._skipInterceptor) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {

      if (originalRequest.url.includes('refresh-token') || originalRequest.url.includes('login')) {
        console.warn('⚠️ Refresh/Login request failed with 401. Logging out...');
        const userRole = localStorage.getItem('userRole') || 'client';
        tokenManager.logout(userRole, true);
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      if (isRefreshingToken) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            return axios(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      isRefreshingToken = true;

      try {
        const userRole = localStorage.getItem('userRole') || 'client';
        const newToken = await tokenManager.refreshToken(userRole);

        // ✅ تحديث الـ default headers أولاً
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

        // ✅ تحديث الطلب الأصلي
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

        processQueue(null, newToken);
        isRefreshingToken = false;

        // ✅ إعادة الطلب بـ config محدّث
        return axios(originalRequest);

      } catch (refreshError) {
        processQueue(refreshError, null);
        isRefreshingToken = false;

        // ✅ تسجيل خروج فقط إذا لم يكن خطأ شبكة
        if (refreshError.code !== 'ECONNABORTED') {
          const userRole = localStorage.getItem('userRole') || 'client';
          tokenManager.logout(userRole, true);
        }

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

/**
 * ✅ Request Interceptor - إضافة التوكن تلقائياً لكل طلب
 */
axios.interceptors.request.use(
  (config) => {
    // تجنب إضافة التوكن للطلبات التي تحتوي بالفعل على Authorization
    if (!config.headers['Authorization']) {
      const userRole = localStorage.getItem('userRole');
      if (userRole) {
        const token = tokenManager.getStoredToken(userRole);
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;